<div class="W">
    <sfcu-message [type]="MessageType.KO">
        Suite à une indisponibilité technique nous vous invitons à réessayer ultèrieurement.
    </sfcu-message>
</div>

<div class="actions c">
    <sfc-btn-retour [class]="'btn4'" text="Retour à l'accueil"></sfc-btn-retour>
</div>

